// extracted by mini-css-extract-plugin
export default {"TeamTitle":"TeamTitle_TeamTitle__bKiAP"};